import { Divida } from "../../../../../../../../../types/divida-interface";
// import { PrestacoesData } from "../../../../../../../../../types/proposta-data-interface";

interface TabelaAcordoParcelasProps {
  prestacoes: Divida[]
}
export const TabelaAcordoParcelas = ({ prestacoes }: TabelaAcordoParcelasProps) => {

  return (
    <div className="my-2">
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block w-full p-1.5 align-middle">
            <div className="max-h-[350px] overflow-hidden overflow-y-auto rounded-sm border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="sticky top-0 bg-gray-300 ">
                  <tr>
                    <th scope="col" className="th-cadastro text-primary">
                      Nº Contrato
                    </th>
                    {/* <th scope="col" className="th-cadastro">
                      Parcela
                    </th> */}
                    <th scope="col" className="th-cadastro text-primary">
                      Vencimento
                    </th>
                    <th scope="col" className="th-cadastro text-primary">
                      Valor Atualizado
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {prestacoes && prestacoes?.length > 0 && prestacoes.map(prest => (
                    <tr key={prest.id}>
                      <td className="td-cadastro">{prest.contrato}</td>

                      <td className="td-cadastro">{prest.datvenci}</td>
                      <td className="td-cadastro">R$ {prest.valorpago}</td>
                    </tr>

                  ))}

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
